import React from 'react';
import { main } from './Button.module.css';

export default ({ children, ...props }) => <button className={main} {...props}>{children}</button>;
